import React from "react";
import { Box, Chip, Link, Stack, Tooltip, Typography } from "@mui/material";
import PersonalImageSlicesCard from "./PersonalImageSlicesCard";
import { MarkdownRenderer } from "./Components";
import { withProtocol } from "./utils";

const SiteHeader = ({ personalInfo, variant = "default" }) => {
  const isDetailPane = variant === "detailPane";

  return (
    <Box
      sx={{
        mb: isDetailPane ? 0 : "2rem",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
          mb: "1rem",
        }}
      >
        <Typography
          variant="h1"
          sx={{ fontWeight: "bold", color: "text.primary" }}
        >
          Hello!
        </Typography>
        <Box
          component="img"
          src={personalInfo.portrait || "/portrait.jpg"}
          alt="Portrait of Leo"
          sx={{
            width: isDetailPane ? 160 : 200,
            height: isDetailPane ? 160 : 200,
            borderRadius: "1rem",
            objectFit: "cover",
            flexShrink: 2,
          }}
        />
      </Box>
      {personalInfo.description.map((info, index) => {
        return <MarkdownRenderer key={index} content={info} />;
      })}
      <PersonalImageSlicesCard />
      {personalInfo.now && (
        <Box
          sx={{
            mt: 2,
            p: 2,
            borderRadius: "1rem",
            bgcolor: isDetailPane ? "action.selected" : "action.hover",
          }}
        >
          <Typography sx={{ mb: 1, color: "text.secondary", fontWeight: 600 }}>
            Now
          </Typography>
          <Stack spacing={0.75}>
            {personalInfo.now.focus && (
              <Typography variant="body2" color="text.secondary">
                <Box
                  component="span"
                  sx={{ color: "text.primary", fontWeight: 600 }}
                >
                  Focus:
                </Box>{" "}
                {personalInfo.now.focus}
              </Typography>
            )}
            {personalInfo.now.learning && (
              <Typography variant="body2" color="text.secondary">
                <Box
                  component="span"
                  sx={{ color: "text.primary", fontWeight: 600 }}
                >
                  Learning:
                </Box>{" "}
                {personalInfo.now.learning}
              </Typography>
            )}
            {personalInfo.now.building && (
              <Typography variant="body2" color="text.secondary">
                <Box
                  component="span"
                  sx={{ color: "text.primary", fontWeight: 600 }}
                >
                  Building:
                </Box>{" "}
                {personalInfo.now.building}
              </Typography>
            )}
            {personalInfo.now.next && (
              <Typography variant="body2" color="text.secondary">
                <Box
                  component="span"
                  sx={{ color: "text.primary", fontWeight: 600 }}
                >
                  Next:
                </Box>{" "}
                Joining{" "}
                <Tooltip
                  title={personalInfo.now.next.tooltipText}
                  followCursor
                  placement="bottom"
                >
                  <Link
                    href={personalInfo.now.next.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    color="secondary"
                    underline="hover"
                    variant="body2"
                  >
                    {personalInfo.now.next.text}
                  </Link>
                </Tooltip>{" "}
                as a Software Engineer
              </Typography>
            )}
          </Stack>
        </Box>
      )}
      <Box
        sx={{
          mt: 2,
          p: 2,
          borderRadius: "1rem",
          bgcolor: isDetailPane ? "action.selected" : "action.hover",
        }}
      >
        <Typography sx={{ mb: 1, color: "text.secondary", fontWeight: 600 }}>
          Let's connect
        </Typography>
        <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
          <Chip
            clickable
            component="a"
            href={`mailto:${personalInfo.email}`}
            label="Email"
            sx={{ borderRadius: "999px" }}
          />
          <Chip
            clickable
            component="a"
            href={withProtocol(personalInfo.linkedin)}
            target="_blank"
            rel="noopener noreferrer"
            label="LinkedIn"
            sx={{ borderRadius: "999px" }}
          />
          <Chip
            clickable
            component="a"
            href={withProtocol(personalInfo.github)}
            target="_blank"
            rel="noopener noreferrer"
            label="GitHub"
            sx={{ borderRadius: "999px" }}
          />
        </Stack>
      </Box>
    </Box>
  );
};

export default SiteHeader;
